var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01546 19.9892H16.5827C18.3744 19.9892 19.227 19.4496 19.227 18.2622C19.227 15.4344 15.6544 11.3438 9.80445 11.3438C3.94368 11.3438 0.371094 15.4344 0.371094 18.2622C0.371094 19.4496 1.22376 19.9892 3.01546 19.9892ZM2.50817 18.3594C2.22755 18.3594 2.10882 18.2839 2.10882 18.0572C2.10882 16.2764 4.85031 12.9736 9.80445 12.9736C14.7478 12.9736 17.4893 16.2764 17.4893 18.0572C17.4893 18.2839 17.3813 18.3594 17.1007 18.3594H2.50817ZM9.80445 9.99461C12.3733 9.99461 14.4671 7.71722 14.4671 4.93254C14.4671 2.16945 12.384 0 9.80445 0C7.24643 0 5.14174 2.21263 5.14174 4.95413C5.14174 7.72801 7.23564 9.99461 9.80445 9.99461ZM9.80445 8.36482C8.22863 8.36482 6.87946 6.86455 6.87946 4.95413C6.87946 3.07609 8.20703 1.62979 9.80445 1.62979C11.4126 1.62979 12.7294 3.04372 12.7294 4.93254C12.7294 6.84296 11.3911 8.36482 9.80445 8.36482Z",
    fill: "#EA6C52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.1399dcbf55cadc2b384ac0fdd26cf217.svg";
export { ForwardRef as ReactComponent };